import React from "react";

const AREA_COLORS = { credit: "#2F6F8F", savings: "#3E6B37", security: "#A9712A" };

/**
 * "How Your Persona Can Advance" — Credit Health, Savings Growth,
 * Financial Security. Each row: advantage · obstacle · the habit we help build.
 */
export const AdvanceRows = ({ advance }) => {
  if (!advance?.length) return null;
  return (
    <section className="mt-12" data-testid="result-advance">
      <p className="eyebrow text-[#C05C3D]">Three signs of advancement</p>
      <h2 className="font-serif text-3xl sm:text-4xl text-[#2C302E] mt-2 leading-tight">
        How Your Persona Can Advance
      </h2>
      <div className="mt-8 space-y-4">
        {advance.map((row) => {
          const accent = AREA_COLORS[row.key] || "#2C302E";
          return (
            <article
              key={row.key}
              className="bg-white border border-[#E6E3DB] border-l-4 p-5 sm:p-6"
              style={{ borderLeftColor: accent }}
              data-testid={`result-advance-${row.key}`}
            >
              <h3 className="font-serif text-2xl text-[#2C302E]">{row.area}</h3>
              <div className="mt-4 grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
                <div>
                  <p className="eyebrow text-[#3E6B37]">Your advantage</p>
                  <p className="mt-1.5 text-sm text-[#2C302E] leading-relaxed">{row.advantage}</p>
                </div>
                <div>
                  <p className="eyebrow text-[#C05C3D]">The obstacle</p>
                  <p className="mt-1.5 text-sm text-[#2C302E] leading-relaxed">{row.obstacle}</p>
                </div>
                <div>
                  <p className="eyebrow" style={{ color: accent }}>The habit we help you build</p>
                  <p className="mt-1.5 text-sm text-[#2C302E] leading-relaxed">{row.habit}</p>
                </div>
              </div>
            </article>
          );
        })}
      </div>
      <p className="mt-3 text-xs text-[#787671] leading-relaxed max-w-2xl" data-testid="result-advance-disclaimer">
        These are habits that may support each outcome. Credit, savings, and security results depend on
        many factors — utilization, account history, income, and more — so results vary. No specific
        score, amount, or outcome is promised.
      </p>
    </section>
  );
};
